




















































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import CustomContainer from '@/components/Globals/CustomContainer.vue';
import baseSpinner from '@/components/Spinner';
import CustomImage from '@/components/Globals/CustomImage.vue';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';

const swiperOptions = {
  slidesPerView: 4.5,
  slidesPerGroup: 1,
  loop: false,
  loopedSlides: 0,
  speed: 300,
  freeMode: true,
  freeModeMomentum: true,
  freeModeMomentumRatio: 0.9,
  breakpoints: {
    375: {
      slidesPerView: 5.5,
    },
    768: {
      slidesPerView: 7,
      freeModeMomentumRatio: 0.75,
    },
  },
  shortSwipes: false,
  watchSlidesProgress: true,
  watchSlidesVisibility: true
};

@Component({
  components: {
    CustomContainer,
    baseSpinner,
    CustomImage,
    Swiper,
    SwiperSlide
  }
})
export default class PatternMakerSwatchesCarousel extends Vue {
  enableCarouselNavigation = true;
  enableSwiper = false;
  isClicked = false;
  swiperOptions = {
    ...swiperOptions,
    navigation: {
      prevEl: '.patternmaker-patternmaker-view-thumbnails-wrapper-nav-button-previous.swatches',
      nextEl: '.patternmaker-patternmaker-view-thumbnails-wrapper-nav-button-next.swatches'
    }
  }

  @Prop({default: () => []})
  swatches!: any[];

  @Prop({default: false})
  enabled!: boolean;

  @Prop({default: false})
  slideToSelectedItem!: boolean;

  @Prop()
  currentSwatch!: String | Number;

  @Watch('swatches')
  public watchSwatches (){
    this.checkEnableCarouselNavigation();
  }

  get swiper() {
    return (this.$refs as any).swiper.$swiper;
  }

  checkEnableLoop() {
    let enableLoop;
    const viewportWidth = window.innerWidth;
    const breakpoints = this.swiperOptions.breakpoints ? Object.keys(this.swiperOptions.breakpoints).sort((a, b) => Number(a)-Number(b)) : [];
    if (!breakpoints.length || viewportWidth < Number(breakpoints[0])) {
      enableLoop = this.swatches.length > this.swiperOptions.slidesPerView;
    }
    for (let i = 0; i < breakpoints.length - 1 && !enableLoop; i++) {
      if (viewportWidth >= Number(breakpoints[i]) && viewportWidth < Number(breakpoints[i + 1])) {
        enableLoop = this.swatches.length > (this as any).swiperOptions.breakpoints[breakpoints[i]].slidesPerView;
      }
    }
    if (!enableLoop && breakpoints.length && viewportWidth >= Number(breakpoints[breakpoints.length - 1])) {
      enableLoop = this.swatches.length > (this as any).swiperOptions.breakpoints[breakpoints[breakpoints.length - 1]].slidesPerView;
    }
    return enableLoop;
  }

  checkEnableCarouselNavigation() {
    if (!this.swatches.length) return;
    const viewportWidth = window.innerWidth;
    const enableLoop = this.checkEnableLoop();
    if (this.swiperOptions.loop !== enableLoop) (this as any).swiperOptions.loop = enableLoop;
    if (enableLoop && (this.swatches.length !== this.swiperOptions.loopedSlides)) this.swiperOptions.loopedSlides = this.swatches.length;
    if (enableLoop && this.swatches) this.swiperOptions.loopedSlides = this.swatches.length;
    (this as any).enableCarouselNavigation = enableLoop && viewportWidth >= 768;
    this.enableSwiper = !!this.swatches.length;
  }

  swatchTouched(event: any) {
    this.swiper.updateSlides();
    if (this.isClicked || !this.enabled) return;
    this.isClicked = true;
    const diff = this.swiper.touches.startX - this.swiper.touches.currentX;
    if (diff >= -1 && diff <= 1) {
      this.swatchClicked(event);
    }
    this.isClicked = false;
  }

  swatchClicked(event: any) {
    let eventAction = 'pattern maker';
    const id = event.target.getAttribute('data-swatch-id');
    const swatch = this.swatches.find(swatch => swatch.id === id);
    this.$emit('swatch-selected', swatch);
    if (this.$store.getters['utils/useEcomDataLayerFormat']) {
      (this as any).$patternMakerDatalayer.logAnalyticsEvent({action: 'Select Base Pattern', eventLabel: swatch.id});
    }
    if (this.$store.getters['patternMaker/isSecondComponentFlow']) eventAction += ' - second component';
  }

  moveCurrentSwatchIntoView() {
    const currentSwatchIndex = this.currentSwatch ? this.swatches.findIndex(swatch => swatch.id === this.currentSwatch) : -1;
    if (currentSwatchIndex < 0) return;
    else this.$nextTick(() => this.swiper.slideToLoop(currentSwatchIndex));
  }

  created() {
    this.checkEnableCarouselNavigation();
    this.$eventBus.$on('patternmaker-move-current-swatch-into-view', (this as any).moveCurrentSwatchIntoView);
    window.addEventListener('resize', (this as any).checkEnableCarouselNavigation);
  }

  mounted() {
    if (this.swatches.length && this.currentSwatch && this.slideToSelectedItem) this.moveCurrentSwatchIntoView();
  }

  beforeDestroy() {
    this.$eventBus.$off('patternmaker-move-current-swatch-into-view', this.moveCurrentSwatchIntoView);
    window.removeEventListener('resize', this.checkEnableCarouselNavigation);
  }
}
